import request from '../utils/request';

// 获取帖子列表
export const getPostList = (params) => {
  return request({
    url: '/api/vincent/posts',
    method: 'GET',
    params
  });
};

// 获取帖子详情
export const getPostDetail = (postId) => {
  return request({
    url: `/api/vincent/posts/${postId}`,
    method: 'GET'
  });
};

// 删除帖子
export const deletePost = (postId) => {
  return request({
    url: `/api/vincent/posts/${postId}`,
    method: 'DELETE'
  });
};

// 批量删除帖子
export const batchDeletePosts = (data) => {
  return request({
    url: '/api/vincent/posts/batch-delete',
    method: 'POST',
    data
  });
};

// 更新帖子状态
export const updatePostStatus = (postId, data) => {
  return request({
    url: `/api/vincent/posts/${postId}/status`,
    method: 'PUT',
    data
  });
};
